import { env as t } from './env.js';
function l(n) {
  var u;
  return t.isServer ? null : n == null ? document : (u = n == null ? void 0 : n.ownerDocument) != null ? u : document;
}
function r(n) {
  var u, o;
  return t.isServer ? null : n == null ? document : (o = (u = n == null ? void 0 : n.getRootNode) == null ? void 0 : u.call(n)) != null ? o : document;
}
function e(n) {
  var u, o;
  return (o = (u = r(n)) == null ? void 0 : u.activeElement) != null ? o : null;
}
function d(n) {
  return e(n) === n;
}
export { e as getActiveElement, l as getOwnerDocument, r as getRootNode, d as isActiveElement };